import { DrawerBody, DrawerTextBlock } from "../Drawer";
import { DefaultFallback, withErrorBoundary } from "../ErrorBoundary";
import { AuthFormNewPassword, AuthNotification } from "./components";
import { notificationUID } from "./uids";

const { NEW_PASSWORD: NEW_PASSWORD_NOTIFICATION_UID } = notificationUID;

const NewPassword = () => (
    <>
        <DrawerBody>
            <DrawerTextBlock
                title="Promjena lozinke"
                description="Upiši novu lozinku za svoj korisnički račun."
            />
            <AuthFormNewPassword />
        </DrawerBody>
        <AuthNotification uid={NEW_PASSWORD_NOTIFICATION_UID} />
    </>
);
export default withErrorBoundary(NewPassword, {
    FallbackComponent: (err) => <DefaultFallback err={err} />,
});
